import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import DynamicFormContainer from "./UI/DynamicFormContainer";
import { PatientConfirmationPageContainer } from "./UI/screens/confirmationPage/PatientConfirmationPageContainer";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { instkey } from "./config/Constants";
import "./App.scss";

// Helper to get the session token from cookies (requires cookie not be HttpOnly)
const getSessionFromCookie = () => {
  const cookieString = document.cookie;
  const cookies = cookieString.split(';');
  const sessionCookie = cookies.find(cookie => cookie.trim().startsWith("SessionToken="));
  return sessionCookie ? sessionCookie.split('=')[1] : null;
};

// Get a tab-specific session using sessionStorage.
// If a token is already saved for this tab, use it. Else, get it from the cookie and save it.
const getTabSessionToken = () => {
  let token = sessionStorage.getItem("SessionToken");
  if (!token) {
    token = getSessionFromCookie();
    if (token) {
      sessionStorage.setItem("SessionToken", token);
    }
  }
  return token;
};

const appInsights = new ApplicationInsights({ config: { instrumentationKey: instkey } });
appInsights.loadAppInsights();
appInsights.trackPageView();

const App = () => {
  // Use the tab-specific token from sessionStorage (or cookie if not yet stored)
  const session = {
    id: getTabSessionToken(), // Uses the API's session token, saved per tab in sessionStorage.
    form: 1,
  };

  return (
    <Router basename={"/patient"}>
      <div className="app">
        <Switch>
          <Route path="/" exact render={() => <DynamicFormContainer session={session} />} />
          <Route path="/patientConfirmationPage" render={() => <PatientConfirmationPageContainer session={session} />} />
        </Switch>
      </div>
    </Router>
  );
};

export default App;